import React from 'react';
import { scrollToTop } from '../../../lib';
import { Link, generatePath } from 'react-router-dom';
import routes from '../../../pages/landingPage/routes';

export type MenuItem = {
    slug: string;
    title: string;
};

export const BlogSubmenuLinks = ({
    homeTitle,
    items,
    selected,
}: {
    homeTitle: string;
    items: MenuItem[];
    selected?: string;
}) => {
    return (
        <>
            <Link
                onClick={() => {
                    scrollToTop();
                }}
                to={routes.blog.path}>
                {selected ? homeTitle : <strong>{homeTitle}</strong>}
            </Link>
            {items.map((s, i) => (
                <Link
                    key={i}
                    onClick={() => {
                        scrollToTop();
                    }}
                    to={generatePath(routes.blog.category.path, {
                        categorySlug: s.slug,
                    })}>
                    {s.slug === selected ? <strong>{s.title}</strong> : s.title}
                </Link>
            ))}
            <Link
                onClick={() => {
                    scrollToTop();
                }}
                to={routes.blog.news.path}>
                {selected === 'news' ? <strong>AludeNews</strong> : 'AludeNews'}
            </Link>
        </>
    );
};
